export default __webpack_public_path__ + "static/media/product-image-hover-18.2bab993c.jpg";